// extracted by mini-css-extract-plugin
export default {"TeamsUI__teamholders":"Teams_TeamsUI__teamholders__0RyLg","TeamsUI__gameName":"Teams_TeamsUI__gameName__R2SjH","TeamsUI__spacer":"Teams_TeamsUI__spacer__obymo"};